import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import chatHomeListCacheConfig from '@/client/exchanges/cacheExchange/chatHomeListCacheConfig';
import insertIntoCachedListBaseQueries from '@/client/exchanges/cacheExchange/insertIntoCachedListBaseQueries';

export default function insert_chat_person_preference_one(
  parent: {
    insert_chat_person_preference_one: {
      chat_id: string;
      person_id: string;
    } | null;
  },
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  const preference = parent.insert_chat_person_preference_one;
  if (preference) {
    const chatId = preference.chat_id;
    if ('notification_preference' in preference) {
      cache.link({ __typename: 'chat', id: chatId }, 'preference', {
        __typename: 'chat_person_preference',
        chat_id: chatId,
        person_id: preference.person_id,
      });
    }
    insertIntoCachedListBaseQueries(cache, [chatId], chatHomeListCacheConfig);
  }
}
